import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchBalanceModificationTransactionsCreate = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'createBalanceModificationTransaction',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    adjustment: payload.params.adjustment,
    comments: payload.params.comments,
    description: payload.params.description,
    effectiveDateTime: moment(payload.params.effectiveDateTime).set({ second: 0 }).format('YYYY-MM-DD HH:mm:ss'),
    impcCode: payload.params.impcCode,
  });
};

export default apiFetchBalanceModificationTransactionsCreate;
